import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone, Mail, ArrowUp } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-white border-t border-neutral-200 mt-20">
      {/* Socials */}
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12">
        <div className="flex flex-col items-center text-center">
          <h3 className="text-2xl font-bold text-neutral-800 mb-6">Seguici sui Socials</h3>
          <div className="flex items-center gap-6">
            {[
              { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61567260762774&sk=reels_tab', label: 'Facebook' },
              { icon: Instagram, href: 'https://www.instagram.com/bettisrl', label: 'Instagram' },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 rounded-full bg-[#d62828] text-white flex items-center justify-center hover:bg-[#b41f1f] transition-all hover:scale-110"
                aria-label={s.label}
              >
                <s.icon size={22} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Top divider with TOP button */}
      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-3 flex justify-end">
          <button
            onClick={scrollTop}
            className="flex items-center gap-1 text-xs font-bold text-neutral-600 hover:text-[#d62828] transition-colors"
          >
            <ArrowUp size={14} /> TOP
          </button>
        </div>
      </div>

      {/* Bottom area */}
      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <Logo size="md" />
              <p className="mt-4 text-sm text-neutral-600">
                Audio · Lights · Video — Noleggio professionale per cinema, broadcast, eventi e produzioni.
              </p>
            </div>
            <div className="text-sm">
              <h4 className="font-bold text-neutral-800 mb-3">Link Utili</h4>
              <ul className="space-y-2 text-neutral-600">
                <li><Link to="/condizioni" className="hover:text-[#d62828]">Condizioni di Noleggio</Link></li>
                <li><Link to="/privacy" className="hover:text-[#d62828]">Privacy</Link></li>
                <li><Link to="/cookie" className="hover:text-[#d62828]">Cookie Policy</Link></li>
              </ul>
            </div>
            <div className="text-sm">
              <h4 className="font-bold text-neutral-800 mb-3">Contatti</h4>
              <ul className="space-y-2 text-neutral-600">
                <li className="flex items-start gap-2">
                  <MapPin size={16} className="text-[#d62828] mt-0.5 flex-shrink-0" />
                  Via Cassia, Loc. Cipressino SNC, 50028 Barberino Tavarnelle (FI)
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={16} className="text-[#d62828]" /> +39 055 5180105
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={16} className="text-[#d62828]" /> +39 339 2020405
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={16} className="text-[#d62828]" /> info@bettisrl.net
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-neutral-200 pt-6 text-center text-xs text-neutral-500">
            © {new Date().getFullYear()} Betti S.R.L. · P. IVA/C.F. 01589500527 · Cap. Soc. € 10.000,00 i.v. · Codice SDI 9SUB64Q
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
